<template>
  <BaseContainer
    class="limit-config-container"
    :permission-list="['trading-partner']"
  >
    <template v-slot:header-title>
      {{ getTextMenu('limits', 'Painel de Gestão e Limites') }}
    </template>
    <template v-slot:header-title-description>
      Configure e consulte o consumo de limites da sua operação.
    </template>

    <BaseContainer
      class="mt-8"
      :active-spacer="true"
    >
      <template v-slot:header-title>
        Consumo de Limites
      </template>
      <template v-slot:header-title-description>
        Consulte o consumo de limites da sua operação.
      </template>
      <template v-slot:header-actions>
        <v-spacer />

        <v-dialog
          v-model="isModalActive"
          persistent
          transition="slide-y-reverse-transition"
          content-class="v-dialog--fullscreen"
        >
          <template v-slot:activator="{ on }">
            <div class="d-flex">
              <BaseButton
                :has-icon="true"
                v-on="on"
              >
                <v-icon>settings</v-icon>
              </BaseButton>
            </div>
          </template>
          <BaseModal
            style="height: 100vh; flex-wrap: nowrap;"
            :middle-image="modalInfo.middleImage"
            :show-indeterminate-progress="modalInfo.showIndeterminateProgress"
            :top-slot-content-title="modalInfo.topSlotContentTitle"
            :remove-button-close="modalInfo.removeButtonClose"
            :middle-slot-content-text-highlight="modalInfo.middleSlotContentTextHighlight"
            :middle-slot-content-text="modalInfo.middleSlotContentText"
            :middle-check-agree="modalInfo.middleCheckAgree"
            :bottom-buttons-align="modalInfo.bottomButtonsAlign"
            :bottom-slot-content-button-cancel-label="modalInfo.bottomSlotContentButtonCancelLabel"
            :bottom-slot-content-button-confirm-label="modalInfo.bottomSlotContentButtonConfirmLabel"
            :remove-button-cancel="modalInfo.removeButtonCancel"
            :remove-button-confirm="modalInfo.removeButtonConfirm"
            :modal-full-screen="true"
            @on-cancel="() => isModalActive = false"
            @on-confirm="() => null"
          >
            <div class="my-4">
              <v-tabs
                vertical
                fixed-tabs
                class="limit-config--tabs"
              >
                <v-tab>
                  Cadastrar Limite
                </v-tab>
                <v-tab-item :transition="false">
                  <BaseContainer class="mx-6">
                    <template v-slot:header-title>
                      Cadastrar limite
                    </template>
                    <template v-slot:header-title-description>
                      Configure o limite da sua operação.
                    </template>
                    <v-divider class="mb-4" />
                    <v-tabs
                      v-model="tabIndex"
                      class="default--tabs"
                    >
                      <v-tab class="default--tabs">
                        Upload de arquivo
                      </v-tab>
                      <v-tab-item :transition="false">
                        <v-card>
                          <v-card-text style="max-width: 440px; margin: 0 auto;">
                            <div class="color--text-black-054 body-1 text-center my-8">
                              <v-icon style="font-size: 60px;">
                                mdi-speedometer
                              </v-icon>
                              <h3 class="headline mb-4 mt-2 text-center font-weight-bold">
                                Upload de arquivo de limite
                              </h3>
                              <BaseDragAndDrop
                                integration-id="limit"
                              />
                              <p class="mt-4">
                                <b>Atenção: O upload substituirá o arquivo anteriormente cadastrado.</b>
                              </p>
                              <p class="mt-4">
                                Extensões permitidas: <b>.xls, .xlsx, .csv</b>.
                                <br>
                                Tamanho máximo para upload do arquivo: <b>1000Kb</b>.
                              </p>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab class="default--tabs">
                        Cadastro manual
                      </v-tab>
                      <v-tab-item :transition="false">
                        <v-card>
                          <v-card-text style="max-width: 440px; margin: 0 auto;">
                            <div class="color--text-black-054 body-1 text-center my-8">
                              <v-icon style="font-size: 60px;">
                                mdi-speedometer
                              </v-icon>
                              <h3 class="headline mb-4 mt-2 text-center font-weight-bold">
                                Cadastro manual de limite
                              </h3>
                              <BaseCard
                                :base-card-container-classes="'mt-4'"
                                :has-main-container="true"
                                :base-card-title-class="'font-weight-bold base-card-title-medium gray74--text'"
                              >
                                <v-form
                                  ref="formLimitAmount"
                                  v-model="formLimit"
                                >
                                  <div class="pa-6 ">
                                    <BaseInput
                                      ref="limitAmount"
                                      v-model="modelLimitAmount"
                                      v-money="amountMask"
                                      :rules="[isValid, isAmountValid]"
                                      label="Limite Total*"
                                    />
                                  </div>
                                  <div class="pa-6 app-align-items-center">
                                    <v-spacer />
                                    <BaseButton
                                      type="text"
                                      color="primary"
                                      button-class="ma-0 mr-4"
                                      @click="clearForm()"
                                    >
                                      Cancelar
                                    </BaseButton>
                                    <BaseButton
                                      color="primary"
                                      button-class="ma-0"
                                      :is-disabled="!formLimit"
                                      @click="sendLimitAmount(modelLimitAmount)"
                                    >
                                      Cadastrar
                                    </BaseButton>
                                  </div>
                                </v-form>
                              </BaseCard>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </BaseContainer>
                </v-tab-item>
                <v-tab>
                  Informar Liquidação
                </v-tab>
                <v-tab-item :transition="false">
                  <BaseContainer class="mx-6">
                    <template v-slot:header-title>
                      Informar liquidação
                    </template>
                    <template v-slot:header-title-description>
                      Atualize o limite da sua operação.
                    </template>
                    <v-divider class="mb-4" />
                    <v-card elevation="0">
                      <v-card-text style="max-width: 440px; margin: 0 auto;">
                        <div class="color--text-black-054 body-1 text-center my-8">
                          <v-icon style="font-size: 60px;">
                            mdi-sync
                          </v-icon>
                          <h3 class="headline mb-4 mt-2 text-center font-weight-bold">
                            Upload de arquivo retorno/liquidação
                          </h3>
                          <BaseDragAndDrop
                            integration-id="updateLimit"
                          />
                          <p class="mt-4">
                            <b>Atenção: O upload substituirá o arquivo anteriormente cadastrado.</b>
                          </p>
                          <p class="mt-4">
                            Extensões permitidas: <b>.xls, .xlsx, .csv</b>.
                            <br>
                            Tamanho máximo para upload do arquivo: <b>1000Kb</b>.
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                  </BaseContainer>
                </v-tab-item>
              </v-tabs>
            </div>
          </BaseModal>
        </v-dialog>
      </template>
      <v-divider class="mb-4" />
      <v-row>
        <v-card
          v-for="(card, index) in cardList"
          :key="index"
          :height="80"
          :width="300"
          class="card"
          :class=" {'card-dark' : card.color === 'primary', 'ml-0' : index === 0, 'activate-hover': card.link } "
          outlined
          :to="card.link ? card.link : null"
        >
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-card-title class="py-2">
              <div>
                <h3
                  class="subtitle-2 font-weight-bold text-capitalize"
                  :class=" {'headline' : card.color !== 'primary'} "
                >
                  {{ card.name }}
                </h3>
                <div class="app-font-semibold mt-2 text-h5">
                  {{ card.amount | formatCurrency }}
                </div>
              </div>
            </v-card-title>
            <v-card-actions v-if="card.link">
              <v-icon
                :class="{'card-dark' : card.color === 'primary'}"
                style="align-self: end;"
              >
                mdi mdi-export
              </v-icon>
            </v-card-actions>
          </div>
        </v-card>
      </v-row>
    </BaseContainer>
    <BaseSnackbar
      :active-snackbar="feedback"
      :type-snackbar="feedbackColor"
      :text-snackbar="feedbackMessage"
      @closeSnackbar="feedback = !feedback"
    />
  </BaseContainer>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import BaseModal from '../BaseModal'
import BaseDragAndDrop from '../BaseDragAndDrop'
import ProgramRoles from '../../mixins/ProgramRoles'
import { amountMask } from '../../directives/moneyMasks'
import BaseSnackbarConfiguration from '../../mixins/BaseSnackbarConfiguration'
import BaseSnackbar from '../BaseSnackbar'

export default {
  components: { BaseModal, BaseDragAndDrop, BaseSnackbar },
  mixins: [ ProgramRoles, BaseSnackbarConfiguration ],
  data:() => ({
    tabIndex: 0,
    isModalActive: false,
    modalInfo: {
      showIndeterminateProgress: false,
      topSlotContentTitle: "Configurações",
      removeButtonClose: false,
      middleSlotContentTextHighlight: "",
      middleSlotContentText: "",
      bottomButtonsAlign: "right",
      bottomSlotContentButtonCancelLabel: "Cancelar",
      bottomSlotContentButtonConfirmLabel: "",
      removeButtonCancel: true,
      removeButtonConfirm: true,
      onCancel: null,
      onConfirm: null
    },
    modelLimitAmount: '',
    amountMask,
    formLimit: false
  }),
  computed: {
    ...mapState({
      chartOfAccounts: state => state.accounts.chartOfAccounts
    }),
    cardList(){
      if(this.chartOfAccounts.accounts){
        return this.chartOfAccounts.accounts.map(account => {
          return {
            name: account.name.toLowerCase(),
            amount: account.amount < 0 ? (account.amount * -1) : account.amount
          }
        })
      } else {
        return []
      }
    },
    activeOrganizationInfo() {
      return this.getActiveOrganization() ? this.getActiveOrganization() : { name: '', tax_number: '' }
    }
  },
  watch:{
    activeOrganizationInfo: {
      async handler(){
        await this.apiGetChartOfAccounts(this.activeOrganizationInfo.tax_number)
      },
      deep: true
    }
  },
  methods: {
    ...mapActions(['apiGetChartOfAccounts']),
    async sendLimitAmount(amount){
      try {
        this.clearForm()
        this.showFeedback({
          message: 'Limite cadastrado com sucesso.',
          color: 'success'
        })
      } catch (error) {
        this.showFeedback({
          message: 'Ocorreu um erro ao cadastrar o limite.',
          color: 'error'
        })
      }
    },
    clearForm(){
      this.forceResetInputValue(this, 'limitAmount')
      this.cancelForm(this, 'formLimitAmount')
    }
  }
}
</script>
<style lang="scss">
.limit-config-container {

  .card {
    border-radius: 8px;
    border: 1px solid var(--v-primary-base);
    color: var(--v-primary-base);
    margin: 20px 5px;
  }

  .card-dark {
    background-color: var(--v-primary-base);
    color: white;
  }
}

.limit-config--tabs {
    .v-tab:not(.default--tabs) {
      min-width: 229px;
      height: 40px!important;
      max-height: 40px!important;
      display: block;
      text-align: left;
      padding: 12px 16px;
      text-transform: none;
      letter-spacing: unset;
      color: var(--custom-theme-black-054)!important;
    }
    .v-tab--active:not(.default--tabs)  {
      color: var(--custom-theme-black-054)!important;
      background: var(--custom-theme-black-005);
      font-weight: 600;
    }
    .v-tabs-slider-wrapper {
      display: none;
    }
    .default--tabs  {
      .v-tabs-slider-wrapper{
        display: unset;
      }
    }
  }


</style>
